export const SWITCH_REPORTS_TOGGLED_ITEMS = 'SWITCH_REPORTS_TOGGLED_ITEMS';
